<template>
    <button
        :id="`btn-dosage-${data.id}`"
        @click="showPopover != showPopover"
        class="btn btn-secondary dosage-button"
        type="button"
    >
        <i class="famfamfam-silk calculator m-0"></i>
        <b-popover
            :target="`btn-dosage-${data.id}`"
            :show.sync="showPopover"
            @show="show"
            :container="container"
            custom-class="btn-dosage"
            placement="right"
            boundary="viewport"
        >
            <div class="dosage">
                <header class="card-header">
                    <strong>Dosage Calculator</strong>
                    <i @click="showPopover = false" class="cus-close"></i>
                </header>
                <div>
                    <div class="form-group row mb-1" v-if="isMultiplePatients">
                        <label :for="`patient`" class="col-4 col-form-label"
                            >Patient:</label
                        >
                        <b-col class="pl-0">
                            <b-form-select
                                placeholder="Select patient"
                                v-model="patient"
                                class="form-control"
                            >
                                <option :value="null">Choose patient</option>
                                <option
                                    v-for="(patient, key) in patients"
                                    :key="key"
                                    :value="patient"
                                    >{{ patient.name }}</option
                                >
                            </b-form-select>
                        </b-col>
                    </div>
                    <div class="form-group row mb-1">
                        <label
                            :for="`weight-${data.id}`"
                            class="col-4 col-form-label"
                            >Weight:</label
                        >
                        <b-col cols="2" class="pl-0 pr-0">
                            <b-form-input
                                :id="`weight-${data.id}`"
                                v-model="weight"
                                placeholder="Weight (optional)"
                                step="any"
                                type="number"
                                @wheel="event => event.target.blur()"
                            ></b-form-input>
                        </b-col>
                        <b-col cols="2" class="pl-1 p-0">
                            <b-form-select
                                v-model="weight_unit"
                                class="form-control"
                            >
                                <option
                                    v-for="(unit, key) in vitalweight_resource"
                                    :key="key"
                                    :value="{ id: key, value: unit }"
                                    >{{ unit }}</option
                                >
                            </b-form-select>
                        </b-col>
                        <b-col class="pt-2">{{ weightConversion }}</b-col>
                    </div>
                    <div class="form-group row mb-1">
                        <label
                            :for="`dose-${data.id}`"
                            class="col-4 col-form-label"
                            >Dose:</label
                        >
                        <b-col cols="2" class="p-0">
                            <b-form-input
                                :id="`dose-${data.id}`"
                                v-model="dose"
                                placeholder="Dose (optional)"
                            ></b-form-input>
                        </b-col>
                        <b-col class="pt-2">{{ doseUOM }}</b-col>
                    </div>
                    <b-form-group
                        :label-for="`dose_range_-${data.id}`"
                        label="Dose Range:"
                        class="mb-1"
                        label-cols="4"
                    >
                        <p
                            v-if="dosage"
                            :id="`dose_range_-${data.id}`"
                            class="plain-text"
                        >
                            {{ doseRange }}
                        </p>
                        <p v-else class="plain-text">-</p>
                    </b-form-group>
                    <b-form-group
                        :label-for="`concentration_-${data.id}`"
                        label="Concentration:"
                        class="mb-1"
                        label-cols="4"
                    >
                        <p
                            v-if="dosage"
                            :id="`concentration_-${data.id}`"
                            class="plain-text"
                        >
                            {{ concentration }}
                        </p>
                        <p v-else class="plain-text">-</p>
                    </b-form-group>
                    <b-form-group
                        :label-for="`total_dosage_-${data.id}`"
                        label="Total Dosage:"
                        class="mb-1"
                        label-cols="4"
                    >
                        <p
                            v-if="dosage"
                            :id="`total_dosage_-${data.id}`"
                            class="plain-text"
                        >
                            {{ totalDosage }}
                        </p>
                        <p v-else class="plain-text">-</p>
                    </b-form-group>
                    <b-form-group
                        :label-for="`total_volume_-${data.id}`"
                        label="Total Volume:"
                        class="mb-1"
                        label-cols="4"
                    >
                        <p
                            v-if="dosage"
                            :id="`total_volume_-${data.id}`"
                            class="plain-text"
                        >
                            {{ totalVolume }}
                        </p>
                        <p v-else class="plain-text">-</p>
                    </b-form-group>
                </div>
            </div>
        </b-popover>
    </button>
</template>
<script>
import { get } from "lodash";
export default {
    name: "Dosage",
    props: {
        itemId: { type: String, default: null },
        target: { type: String, default: null },
        data: { type: Object, default: () => ({}) },
        parentId: { type: String, default: null },
        weightData: { type: Object, default: () => ({}) },
        container: { type: String, default: "app" }, // set prop container to other element or null if popover not accepting input, refers https://bootstrap-vue.org/docs/components/popover#overview
        isMultiplePatients: { type: Boolean, default: false }, // for multiple users
        patients: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            appointment_data: {},
            showPopover: false,
            weight_unit: [],
            weight: null,
            dose: "",
            multiplier: {
                mg: 1000000,
                g: 1000,
                kg: 1,
                lbs: 2.204622621848775,
                oz: 35.27396195
            },
            dosage: {
                DoseUnit: null,
                DoseBaseUnit: null,
                DoseRangeMax: null,
                DoseRangeMin: null,
                ConcentrationUnit: null,
                ConcentrationUOM: null
            },
            patient: null
        };
    },
    mounted() {
        let self = this;
        // Define the function to be used in both add and remove event listener
        this.bodyClickListener = function (e) {
            if (
                $(".dosage-button").not(e.target) &&
                $(".dosage-button").has(e.target).length === 0 &&
                $(".popover").has(e.target).length === 0
            ) {
                $(".popover").hide();
                self.showPopover = false;
            }
        };

        // Add event listener
        document.body.addEventListener("click", this.bodyClickListener);
    },
    beforeDestroy() {
        // Remove event listener
        document.body.removeEventListener("click", this.bodyClickListener);
    },
    watch: {
        patient(value, oldValue) {
            this.patientChanged(value);
        }
    },
    computed: {
        weightConversion() {
            if (this.weight_unit.value) {
                let convertWeight;
                let weight =
                    this.weight && !_.isNaN(this.weight) ? this.weight : 0;
                let newWeight;
                let lbs;
                let oz;
                let results;
                switch (this.weight_unit.value.toLowerCase()) {
                    case "kg":
                        newWeight = weight / 0.45359237;
                        lbs = Math.floor(newWeight);
                        oz = ((newWeight - lbs) * 16).toFixed(0);
                        results = {
                            pounds: lbs,
                            ounces: oz
                        };
                        convertWeight =
                            results.pounds + " lbs " + results.ounces + " oz";
                        break;
                    case "g":
                        newWeight = weight / 453.59237;
                        lbs = Math.floor(newWeight);
                        oz = ((newWeight - lbs) * 16).toFixed(0);
                        results = {
                            pounds: lbs,
                            ounces: oz
                        };
                        convertWeight =
                            results.pounds + " lbs " + results.ounces + " oz";
                        break;
                    case "lbs":
                        convertWeight =
                            (weight * 0.45359237).toFixed(2) + " kg";
                        break;
                    case "oz":
                        convertWeight =
                            (weight * 0.02834952).toFixed(2) + " kg";
                        break;
                    default:
                        convertWeight = "-";
                        break;
                }
                return "(" + convertWeight + ")";
            } else {
                return "-";
            }
        },
        doseUOM() {
            if (!this.dosage.DoseUnit && !this.dosage.DoseBaseUnit) {
                return "-";
            } else {
                return (
                    this.getUnit(this.dosage.DoseUnit) +
                    "/" +
                    this.getUnit(this.dosage.DoseBaseUnit)
                );
            }
        },
        doseRange() {
            if (!this.dosage.DoseRangeMin && !this.dosage.DoseRangeMax) {
                return "-";
            } else {
                return (
                    this.dosage.DoseRangeMin +
                    " - " +
                    this.dosage.DoseRangeMax +
                    " " +
                    this.getUnit(this.dosage.DoseUnit) +
                    "/" +
                    this.getUnit(this.dosage.DoseBaseUnit)
                );
            }
        },
        totalDosage() {
            if (parseFloat(this.dose)) {
                let dose_calcd = this.calcd(this.dose);
                if (!isNaN(dose_calcd)) {
                    return (
                        dose_calcd +
                        " " +
                        this.getUnit(this.dosage.DoseUnit) +
                        " (" +
                        this.calcd(this.dosage.DoseRangeMin) +
                        " - " +
                        this.calcd(this.dosage.DoseRangeMax) +
                        " " +
                        this.getUnit(this.dosage.DoseUnit) +
                        ")"
                    );
                }
                return "";
            } else {
                return this.dosage.DoseRangeMin
                    ? this.calcd(this.dosage.DoseRangeMin) +
                          " - " +
                          this.calcd(this.dosage.DoseRangeMax) +
                          " " +
                          this.getUnit(this.dosage.DoseUnit)
                    : "-";
            }
        },
        concentration() {
            if (this.dosage.Concentration) {
                return (
                    this.dosage.Concentration +
                    " " +
                    this.getUnit(this.dosage.ConcentrationUnit) +
                    "/" +
                    this.dosage.ConcentrationUOM
                );
            } else {
                return "-";
            }
        },
        totalVolume() {
            if (this.dosage.Concentration) {
                if (parseFloat(this.dose)) {
                    return (
                        this.calcc(this.dose) +
                        " " +
                        this.dosage.ConcentrationUOM +
                        " (" +
                        this.calcc(this.dosage.DoseRangeMin) +
                        " - " +
                        this.calcc(this.dosage.DoseRangeMax) +
                        " " +
                        this.dosage.ConcentrationUOM +
                        ")"
                    );
                } else {
                    return (
                        this.calcc(this.dosage.DoseRangeMin) +
                        " - " +
                        this.calcc(this.dosage.DoseRangeMax) +
                        " " +
                        this.dosage.ConcentrationUOM
                    );
                }
            } else {
                return "-";
            }
        }
    },
    methods: {
        show() {
            this.$root.$emit("bv::hide::popover");
            let isGetItemDosage = true;

            if (get(this.data, "form_data.dosage")) {
                this.dosage = get(this.data, "form_data.dosage");
                this.dose = this.dosage.Dose;

                // when this.dosage = [], this.dose will be undefined
                isGetItemDosage = this.dose === undefined;
            }

            if (isGetItemDosage && this.itemId) {
                this.getItemDosage(this.itemId).then(dosage => {
                    if (dosage) {
                        this.dosage = {
                            Concentration: dosage.concentration,
                            ConcentrationUnit: dosage.concentration_unit,
                            ConcentrationUOM: dosage.concentration_uom_uom.uom,
                            DoseRangeMin: dosage.dose_range_min,
                            DoseRangeMax: dosage.dose_range_max,
                            Dose: dosage.dose,
                            DoseUnit: dosage.dose_unit,
                            DoseBaseUnit: dosage.dose_b_unit
                        };
                        this.dose = this.dosage.Dose;
                    }
                });
            }

            if (this.isMultiplePatients) {
                this.patientChanged(this.patient);
            } else {
                this.weight = this.weightData.weight
                    ? this.weightData.weight
                    : null;

                let uom = this.weightData.uom
                    ? this.weightData.uom
                    : this._setting.weights_measures === 1
                    ? 75
                    : 72;

                this.weight_unit = {
                    id: uom,
                    value: this.vitalweight_resource[uom]
                };
            }
        },
        patientChanged(patient) {
            this.patient = patient;
            const selectedPatient = this.patients
                ? _.find(this.patients, {
                      id: patient?.id
                  })
                : null;

            if (!selectedPatient) {
                this.patient = null;
                this.weight = null;
            }

            this.weight = patient?.weight?.weight
                ? patient.weight.weight
                : null;

            let uom = patient?.weight?.uom
                ? patient.weight.uom
                : this._setting.weights_measures === 1
                ? 75
                : 72;

            this.weight_unit = {
                id: uom,
                value: this.vitalweight_resource[uom]
            };
        },
        calcd(number) {
            const weight =
                this.weight != null && this.weight != "" ? this.weight : 0;
            var a =
                (number / this.multiplier[this.getUnit(this.dosage.DoseUnit)]) *
                this.multiplier[this.getUnit(this.dosage.DoseBaseUnit)] *
                (parseFloat(weight) /
                    this.multiplier[
                        this.weight_unit.value
                            ? this.weight_unit.value.toLowerCase()
                            : 0
                    ]) *
                this.multiplier[this.getUnit(this.dosage.DoseUnit)];
            return a.toFixed(3);
        },
        getUnit(str) {
            if (!isNaN(str)) {
                return this.weight_resource[str];
            } else {
                return "";
            }
        },
        async getItemDosage(id) {
            const response = await this.$http.get(
                process.env.BARRACUDA + "inventory/" + id + "/dosage"
            );
            if (response) {
                return get(response, "data.response.resource", null);
            }
        },
        calcc(number) {
            const weight =
                this.weight != null && this.weight != "" ? this.weight : 0;
            var a =
                (((((number * parseFloat(weight)) /
                    this.multiplier[
                        this.weight_unit.value
                            ? this.weight_unit.value.toLowerCase()
                            : 0
                    ]) *
                    this.multiplier[this.getUnit(this.dosage.DoseBaseUnit)]) /
                    this.dosage.Concentration) *
                    this.multiplier[
                        this.getUnit(this.dosage.ConcentrationUnit)
                    ]) /
                this.multiplier[this.getUnit(this.dosage.DoseUnit)];
            return a.toFixed(3);
        }
    }
};
</script>
<style lang="scss">
button.dosage-button {
    font-size: 0.65625rem;
    line-height: 1;
    padding: 0.25rem 0.65rem;
}
.btn-dosage.popover {
    min-width: 22rem;
    .dosage {
        .card-footer,
        .card-header {
            margin: -0.5rem -0.75rem;
            padding: 0.5rem;
        }
        .card-header {
            margin-bottom: 1rem;
            font-size: 14px;

            .cus-close {
                cursor: pointer;
                float: right;
            }
        }
        .form-group label {
            font-size: 12px;
        }
        .pt-2 {
            padding-left: 1% !important;
        }
        .col-3 {
            min-width: 32%;
        }
        .col-2 {
            min-width: 19%;
        }
    }
}
</style>
